export default function (target, type, callback) {
  const eventWrapper = function (event) {
    target.removeEventListener(type, eventWrapper)
    callback(event)
  }

  target.addEventListener(type, eventWrapper)
}
